import { TAnalyticsUser } from '../../types/analytics';
import { TApplicationState } from '../../types/redux';
import { IAuthenticatedUser } from '../../types/user';

export function getAnalyticsUser(state: TApplicationState): TAnalyticsUser {
  const { user } = state.userState;

  return {
    userId: (user as IAuthenticatedUser).userId || undefined,
  };
}
